import { NgModule } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { adminGuard } from './guards/admin.guard';
import { AdminComponent } from './components/admin/admin.component';
import {
  AdminGroupsPageComponent,
  AdminKnockoutPageComponent,
  AdminLivePageComponent,
  AdminMaintenancePageComponent,
  AdminMatchesPageComponent,
  AdminNewsPageComponent,
  AdminPlayersPageComponent,
  AdminStandingsPageComponent,
  AdminTeamsPageComponent
} from './components/admin/admin-pages.component';
import { GroupAdminComponent } from './components/admin/group-admin/group-admin.component';
import { KnockoutAdminComponent } from './components/admin/knockout-admin/knockout-admin.component';
import { LiveAdminComponent } from './components/admin/live-admin/live-admin.component';
import { MatchAdminComponent } from './components/admin/match-admin/match-admin.component';
import { NewsAdminComponent } from './components/admin/news-admin/news-admin.component';
import { PlayerRegistryAdminComponent } from './components/admin/player-registry-admin/player-registry-admin.component';
import { StandingsAdminComponent } from './components/admin/standings-admin/standings-admin.component';
import { TeamAdminComponent } from './components/admin/team-admin/team-admin.component';
import { LoginComponent } from './components/login/login.component';
import { PublicDisplayComponent } from './components/public-display/public-display.component';
import { LoadingOverlayComponent } from './components/shared/loading-overlay.component';
import {
  PublicGroupsPageComponent,
  PublicKnockoutPageComponent,
  PublicNewsDetailPageComponent,
  PublicNewsPageComponent,
  PublicSchedulePageComponent,
  PublicStandingsPageComponent,
  PublicTeamDetailPageComponent,
  PublicTeamsPageComponent
} from './components/public-display/public-pages.component';

registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AdminTeamsPageComponent,
    AdminPlayersPageComponent,
    AdminGroupsPageComponent,
    AdminMatchesPageComponent,
    AdminLivePageComponent,
    AdminNewsPageComponent,
    AdminStandingsPageComponent,
    AdminKnockoutPageComponent,
    AdminMaintenancePageComponent,
    TeamAdminComponent,
    GroupAdminComponent,
    MatchAdminComponent,
    LiveAdminComponent,
    NewsAdminComponent,
    PlayerRegistryAdminComponent,
    StandingsAdminComponent,
    KnockoutAdminComponent,
    LoginComponent,
    LoadingOverlayComponent,
    PublicDisplayComponent,
    PublicGroupsPageComponent,
    PublicSchedulePageComponent,
    PublicStandingsPageComponent,
    PublicKnockoutPageComponent,
    PublicTeamsPageComponent,
    PublicTeamDetailPageComponent,
    PublicNewsPageComponent,
    PublicNewsDetailPageComponent
  ],
  imports: [BrowserModule, FormsModule, RouterModule.forRoot([
    { path: '', component: PublicDisplayComponent },
    { path: 'gironi', component: PublicGroupsPageComponent },
    { path: 'calendario', component: PublicSchedulePageComponent },
    { path: 'classifiche', component: PublicStandingsPageComponent },
    { path: 'fase-finale', component: PublicKnockoutPageComponent },
    { path: 'squadre', component: PublicTeamsPageComponent },
    { path: 'squadre/:id', component: PublicTeamDetailPageComponent },
    { path: 'news', component: PublicNewsPageComponent },
    { path: 'news/:id', component: PublicNewsDetailPageComponent },
    { path: 'login', component: LoginComponent },
    { path: 'admin', redirectTo: 'admin/squadre', pathMatch: 'full' },
    { path: 'admin/squadre', component: AdminTeamsPageComponent, canActivate: [adminGuard] },
    { path: 'admin/giocatori', component: AdminPlayersPageComponent, canActivate: [adminGuard] },
    { path: 'admin/gironi', component: AdminGroupsPageComponent, canActivate: [adminGuard] },
    { path: 'admin/calendario', component: AdminMatchesPageComponent, canActivate: [adminGuard] },
    { path: 'admin/live', component: AdminLivePageComponent, canActivate: [adminGuard] },
    { path: 'admin/news', component: AdminNewsPageComponent, canActivate: [adminGuard] },
    { path: 'admin/classifiche', component: AdminStandingsPageComponent, canActivate: [adminGuard] },
    { path: 'admin/fase-finale', component: AdminKnockoutPageComponent, canActivate: [adminGuard] },
    { path: 'admin/operazioni', component: AdminMaintenancePageComponent, canActivate: [adminGuard] },
    { path: '**', redirectTo: '' }
  ])],
  providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }],
  bootstrap: [AppComponent]
})
export class AppModule {}
